import { combineReducers } from 'redux';

import { oldDashboardReducer } from './OldDashboard';
import { dashboardPageReducer } from './DashboardPage';
import { billingReducer } from './Billing';
import { billingDetailsReducer } from './BillingDetails';
import { passwordPageReducer } from './PasswordPage';
import { mobileNumberPageReducer } from './MobileNumberPage';
import { policyReducer } from './Policy';
import { policyDetailsReducer } from './PolicyDetails';
import { claimReducer } from './Claim';
import { ClaimDetailsReducer } from './ClaimDetails';
import { claimEditReducer } from './ClaimEdit';
import { userClaimAdditionalDocumentsReducer } from './ClaimAdditionalDocuments';
import { PolicyClaimReducer } from './PolicyClaim';
import { policyRenewalReducer } from './PolicyRenewal';
import { personalInfoEditReducer } from './PersonalInfoEditPage';
import { otpLinkReducer } from './OtpLink';
import { searchCorporateMemberReducer } from './SearchCorporateMember';
import { insurancePolicyListPageReducer } from './InsurancePolicyListPage';
import { insurancePolicyDetailsPageReducer } from './InsurancePolicyDetailsPage';
import { insurancePolicyUserDetailsPageReducer } from './InsurancePolicyUserDetailsPage';
import { commissionListReducer } from './CommissionList';
import { claimEditModalReducer } from './ClaimEditModal';
import { searchInsurancePolicyUserPageReducer } from './SearchInsurancePolicyUserPage';

export default combineReducers({
  oldDashboardReducer,
  dashboardPageReducer,
  billingReducer,
  billingDetailsReducer,
  passwordPageReducer,
  mobileNumberPageReducer,
  policyReducer,
  policyDetailsReducer,
  claimReducer,
  claimDetails: ClaimDetailsReducer,
  userClaimAdditionalDocumentsReducer,
  claimEditReducer,
  policyClaim: PolicyClaimReducer,
  policyRenewalReducer,
  personalInfoEditReducer,
  otpLinkReducer,
  searchCorporateMemberReducer,
  insurancePolicyListPageReducer,
  insurancePolicyDetailsPageReducer,
  insurancePolicyUserDetailsPageReducer,
  userDashboardCommissionShares: commissionListReducer,
  claimEditModal: claimEditModalReducer,
  searchInsurancePolicyUserPageReducer,
});
